"use client";

import React, { createContext, useContext, useMemo } from "react";

import useHomeSummary from "@/hooks/api/cred/useHomeSummary";
import { HomeSummary } from "@/types";

interface CredContextType {
  summary: HomeSummary | undefined;
  isSummaryLoading: boolean;
}

const CredContext = createContext<CredContextType | undefined>(undefined);

export default function CredProvider({ children }: { children: React.ReactNode }) {
  const { data: summary, isLoading: isSummaryLoading } = useHomeSummary();

  const value = useMemo(
    () => ({
      summary,
      isSummaryLoading,
    }),
    [summary, isSummaryLoading]
  );

  return <CredContext.Provider value={value}>{children}</CredContext.Provider>;
}

export function useCred() {
  const context = useContext(CredContext);
  if (context === undefined) {
    throw new Error("useCred must be used within a CredProvider");
  }
  return context;
}
